
<div>
  <lib-voucher-dash
        [dataService]="voucherSvc" [overlaySvc]="overlaySvc" [modalSvc]="modalSvc"
        [darkMode]="appGlobals.getStoredDarkModeSetting()"
        (closedEmitter)="exitVouchersHome()"></lib-voucher-dash>
</div>

<div style="position: fixed; top: 40%; left: 40%; width: 20%; min-height: 200px; height: auto; max-height: 98%; z-index: 1000; color: #000; border-radius: 10px; display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center;" *ngIf="logoutConfirmationOpen" [ngClass]="{'darkMode': appGlobals.getStoredDarkModeSetting()}" [ngStyle]="{'background-color': appGlobals.getStoredDarkModeSetting() ? '#333' : '#eee'}">
  <h4>Are you sure you want to logout?</h4>
  <div>
    <button type="button" class="btn btn-primary" (click)="confirmLogOut()" tabindex="1" style="margin: 0.25em;">
      <i class="fal me-1 fa-check"></i>
      {{ 'Yes' }}
    </button>
    <button type="button" class="btn btn-outline-secondary" (click)="logoutConfirmationOpen = false; this.overlaySvc.disableOverlay();" tabindex="1" style="margin: 0.25em;">
      <i class="fal fa-times me-1"></i>{{ 'No' }}
    </button>
  </div>
</div>
